<div [ngClass]="{ editable: editable() }" class="custom-mat-form-wrapper editor">
  @if (state.status) {
    @if (editable()) {
      <dojo-button [size]="'s'" [fill]="'outline'" [matMenuTriggerFor]="menu">
        <dojo-topic-status-icon class="mr-1" [status]="state.status.id"></dojo-topic-status-icon>
        <span>{{ state.status.label }}</span>
      </dojo-button>
    } @else {
      <div class="flex items-center justify-center gap-1 rounded border border-neutral-200 p-2">
        <dojo-topic-status-icon class="mr-1" [status]="state.status.id"></dojo-topic-status-icon>
        {{ state.status.label }}
      </div>
    }
  }
</div>

<mat-menu #menu="matMenu" xPosition="before">
  <ng-template matMenuContent>
    <dojo-filterable-items-list
      [itemSize]="36"
      [items]="allStatuses"
      [selected]="[formCtrl().value]"
      [identityFn]="identityFn"
      [filterPropertyValueFn]="filterPropertyValueFn"
      listMode="list"
      (selectItem)="setSelected($event)"
      searchPlaceholder="Select a status"
    >
      <div *dojoListItem="allStatuses; let status" class="option-item">
        <dojo-topic-status-icon [status]="status.id" />
        <span>{{ status.label }}</span>
        <dojo-icon [icon]="'check'" class="option-item-icon" />
      </div>
    </dojo-filterable-items-list>
  </ng-template>
</mat-menu>
